export const COPILOT_SIDEBAR_CONTAINER_CLASS = 'copilot-sidebar-container';
export const COPILOT_GRID_LAYOUT_CLASS = 'copilot-grid-layout';
export const COPILOT_APP_CONTAINER_CLASS = 'copilot-app-container';
export const PANEL_WITH_SCROLL_CLASS = 'with-copilot-scroll-panel';
export const SIDEBAR_CLASS = 'with-copilot-sidebar';